import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  grain_to_grass_grain_kg: 1.2,
  grain_to_grass_grass_kg: 5.0,
  target_weight_per_tray: 5.0,
  standard_cycle_days: 7.0,
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (err) {
      console.error("Failed to load settings:", err);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const save = useCallback(async (next) => {
    const { data } = await api.put("/settings", next);
    setSettings(data);
    return data;
  }, []);

  const value = useMemo(
    () => ({ settings, loaded, save, refresh }),
    [settings, loaded, save, refresh],
  );

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  return useContext(SettingsContext);
}
